import React, { useState } from "react";
import styled from "styled-components";
import completedIcon from "../../Images/CompleteSign.svg";
import inProcessIcon from "../../Images/Process.svg";
import declinedIcon from "../../Images/DeclineIndicator.svg";
import { useLanguage } from "../LangTranslation/LanguageContext";

// Styled components
const OrdersContainer = styled.div`
  width: 100%;
  padding: 13px;
  margin: 15px;
  background-color: #f8f9fa;
  display: flex;
  justify-content: center;
`;
const TableContainer = styled.div`
  margin: 20px !important;
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr {
    padding: 21px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
    font-weight: 600;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 15px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
    font-size: 17px;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }
  .time_div {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 500;
    color: #b0b7c3;
  }
  .transaction-container {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Inter";
    font-weight: 600;
    background-color: #f8f9fa;
    padding: 10px;
    border-radius: 20px;
    width: 100%;
    height: 50px;
    color: #b0b7c3;
  }
  .red-number {
    color: red;
  }
`;

const BankDetailsComponent = ({ bankCashBalanceList }) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const makeStyle = (status) => {
    if (status === "Completed") {
      return {
        color: "#38CB7C",
        background: "#E5F6EF",
        icon: completedIcon,
      };
    } else if (status === "In Process") {
      return {
        color: "#FFBD37",
        background: "#FDF4E0",
        icon: inProcessIcon,
      };
    } else if (status === "Declined") {
      return {
        color: "#FF6464",
        background: "#FFEFEB",
        icon: declinedIcon,
      };
    } else {
      return {
        background: "#59bfff",
        color: "white",
      };
    }
  };

  const data = [
    {
      id: 1,
      paymentNumber: "Payment from #23433",
      amount: "+512.00 OMR",
      status: "Completed",
    },
    {
      id: 2,
      paymentNumber: "Process refund to #23464",
      amount: "+512.00 OMR",
      status: "Declined",
    },
    {
      id: 3,
      paymentNumber: "Payment from #23433",
      amount: "+533.00 OMR",
      status: "Completed",
    },
    {
      id: 4,
      paymentNumber: "Process refund to #23464",
      amount: "+332.00 OMR",
      status: "Declined",
    },
    {
      id: 5,
      paymentNumber: "Payment failed from #54633",
      amount: "+531.00 OMR",
      status: "In Process",
    },
    {
      id: 6,
      paymentNumber: "Process refund to #23464",
      amount: "+332.00 OMR",
      status: "Declined",
    },
    {
      id: 7,
      paymentNumber: "Payment failed from #54633",
      amount: "+435.00 OMR",
      status: "In Process",
    },
    {
      id: 8,
      paymentNumber: "Payment from #23433",
      amount: "+132.00 OMR",
      status: "Declined",
    },
  ];

  const [showAll, setShowAll] = useState(false);

  return (
    <>
      <div
        className="m-2 "
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          color: "#323B4B",
          fontWeight: 600,
        }}
      >
        {t["Bank and Cash Balance"]}
      </div>
      <OrdersContainer>
        <TableContainer>
          <table className="table">
            <thead>
              <tr className="heading_row">
                <th>{t["PAYMENT NUMBER"]}</th>
                <th>{t["AMOUNT"]}</th>
                <th>{t["STATUS"]}</th>
              </tr>
            </thead>
            <tbody>
              {data.slice(0, showAll ? data.length : 3).map((task) => (
                <tr key={task.id}>
                  <td>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={makeStyle(task.status).icon}
                        alt="Status Icon"
                        style={{ marginRight: "10px" }}
                      />
                      <div>
                        {task.paymentNumber.split(" ").map((word, index) => (
                          <span
                            key={index}
                            className={/\d+/.test(word) ? "red-number" : ""}
                          >
                            {word}{" "}
                          </span>
                        ))}
                        <div className="time_div">
                          <span>{t["Today"]} </span>
                          {new Date().toLocaleTimeString()}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{task.amount}</td>
                  <td>
                    <div className="status_div" style={makeStyle(task.status)}>
                      {task.status}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!showAll && (
            <div
              className="transaction-container"
              onClick={() => setShowAll(true)}
            >
              View Transaction Details &gt;
            </div>
          )}
        </TableContainer>
      </OrdersContainer>
    </>
  );
};

export default BankDetailsComponent;
